import { authorizedFetch as fetch, fetchDELETE, fetchPOST, fetchPUT } from '@/helpers/authFetch';
import { CAPITAL_ASC, LAST_NAME } from '@/helpers/constants';
import { usersRequestEndPoint, checkServiceOK } from './serviceConstants';

const USER_TYPES = 'DAIMLER_EXTERNAL,DAIMLER_INTERNAL,DAIMLER_POOLID,DAIMLER_JOINT_VENTURE_PERSON';

const getFilterParams = (columnFilters) => Object.keys(columnFilters).reduce((acc, key) => {
  if (!columnFilters[key]) return acc;

  return `${acc}${key}=${columnFilters[key]}&`;
}, '');

// For users "info" use Dialog
const getUsers = (page = 0, pageSize = 10, sort = LAST_NAME, sortDir = CAPITAL_ASC, userTypes = USER_TYPES) => (
  fetch(`${usersRequestEndPoint}/users?page=${page}&pageSize=${pageSize}&sort=${sort}&sortDir=${sortDir}&userTypes=${userTypes}`)
    .then(checkServiceOK)
);

// For users "info" use Dialog for Filter
const getUsersFilterTable = (signal, columnFilters, page = 0, pageSize = 10, sort = LAST_NAME, sortDir = CAPITAL_ASC, userTypes = USER_TYPES) => (
  fetch(`${usersRequestEndPoint}/users?${getFilterParams(columnFilters)}page=${page}&pageSize=${pageSize}&sort=${sort}&sortDir=${sortDir}&userTypes=${userTypes}`, { signal })
    .then(checkServiceOK));

// For users "info" use Dialog for Level
const getUsersLevel = (level, page = 0, pageSize = 10, sort = LAST_NAME, sortDir = CAPITAL_ASC, fixedLevel = true, userTypes = USER_TYPES) => (
  fetch(`${usersRequestEndPoint}/users?page=${page}&pageSize=${pageSize}&sort=${sort}&sortDir=${sortDir}&userTypes=${userTypes}&level=${level}
  &fixedLevel=${fixedLevel}`)
    .then(checkServiceOK)
);

// For users "info" use Dialog for Filter and Level
const getUsersLevelFilterTable = (signal, level, columnFilters, page = 0, pageSize = 10, sort = LAST_NAME, sortDir = CAPITAL_ASC, fixedLevel = true, userTypes = USER_TYPES) => (
  fetch(`${usersRequestEndPoint}/users?page=${page}&pageSize=${pageSize}&sort=${sort}&sortDir=${sortDir}&userTypes=${userTypes}&level=${level}&fixedLevel=${fixedLevel}&${getFilterParams(columnFilters)}`, { signal })
    .then(checkServiceOK));

const getUsersCampaignManager = (wkz, role, assignedUser) => (
  fetch(`${usersRequestEndPoint}/users/list/plant/${wkz}/role/${role}${assignedUser ? `/assignedUser/${assignedUser}` : ''}`)
    .then(checkServiceOK)
);

const getUsersByRole = (role) => {
  const roles = role && Array.isArray(role) ? role.join(',') : role;

  return (fetch(`${usersRequestEndPoint}/users/list/roles?roles=${roles}`).then(checkServiceOK));
};

const getUsersSettings = (uid) => (
  fetch(`${usersRequestEndPoint}/users/${uid}/settings`).then(checkServiceOK)
);

const getUsersConfiguration = (uid) => (
  fetch(`${usersRequestEndPoint}/users/${uid}/settings/configuration`).then(checkServiceOK)
);

const getUsersSettingsPreferences = (uid) => (
  fetch(`${usersRequestEndPoint}/users/${uid}/settings/executive_summary_preferences`).then(checkServiceOK)
);

const saveUsersSettings = (uid, data) => (
  fetchPUT(`${usersRequestEndPoint}/users/${uid}/settings`, data)
    .then((res) => checkServiceOK(res, true))
);

const saveUsersConfig = (uid, data) => (
  fetchPUT(`${usersRequestEndPoint}/users/${uid}/settings/configuration`, data)
    .then((res) => checkServiceOK(res, true))
);

const saveUsersSettingsPreferences = (uid, data) => (
  fetchPUT(`${usersRequestEndPoint}/users/${uid}/settings/executive_summary_preferences`, data)
    .then((res) => checkServiceOK(res, true))
);

// For users "info" use Dialog
const getUserSearch = (user, updateDRDRoles = false) => (
  fetch(`${usersRequestEndPoint}/users/${user}?clean=${updateDRDRoles}`)
    .then(checkServiceOK)
);

const getCurrentUser = (updateDRDRoles = false) => (
  fetch(`${usersRequestEndPoint}/users/myInfo?clean=${updateDRDRoles}`)
    .then(checkServiceOK)
);

const getStandIns = (signal, uid) => (
  fetch(`${usersRequestEndPoint}/users/${uid}/standins`, { signal })
    .then(checkServiceOK)
);

const saveStandIns = (uid, data) => (
  fetchPOST(`${usersRequestEndPoint}/users/${uid}/standins`, { standInRequestObject: data })
    .then((res) => checkServiceOK(res, true))
);

const editStandIn = (uid, data) => (
  fetchPUT(`${usersRequestEndPoint}/users/${uid}/standins`, { standInRequestObject: data })
    .then((res) => checkServiceOK(res, true))
);

const deleteStandIns = (uid, data) => (
  fetchDELETE(`${usersRequestEndPoint}/users/${uid}/standins`, { standInIds: data })
    .then((res) => checkServiceOK(res, true))
);

const getSuppliers = (signal, columnFilters, page = 0, pageSize = 10) => (
  fetch(`${usersRequestEndPoint}/suppliers?${getFilterParams(columnFilters)}pageNumber=${page}&pageSize=${pageSize}`, { signal })
    .then(checkServiceOK));

const getUsersByList = (userList) => (fetch(`${usersRequestEndPoint}/users/list/${userList?.join(',')}`).then(checkServiceOK));

// ----------------------------------------

export default {
  getUsers,
  getCurrentUser,
  getStandIns,
  getUsersByRole,
  getUsersFilterTable,
  getUsersLevelFilterTable,
  getUsersLevel,
  getUsersCampaignManager,
  getUsersSettings,
  getUsersConfiguration,
  getUsersSettingsPreferences,
  saveUsersSettings,
  saveUsersConfig,
  saveUsersSettingsPreferences,
  saveStandIns,
  editStandIn,
  deleteStandIns,
  getSuppliers,
  getUsersByList,
  getUserSearch,
};
